export default __webpack_public_path__ + "static/GraphikMedium-f58d53eb72d7239d4ca862b0b176fb8f.otf";